import { render, staticRenderFns } from "./ykInputs.vue?vue&type=template&id=0e28d537&scoped=true"
import script from "./ykInputs.vue?vue&type=script&lang=js"
export * from "./ykInputs.vue?vue&type=script&lang=js"
import style0 from "./ykInputs.vue?vue&type=style&index=0&id=0e28d537&scoped=true&lang=css"
import style1 from "./ykInputs.vue?vue&type=style&index=1&id=0e28d537&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e28d537",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\smartlink\\front\\lianhe\\ctruck-lock-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e28d537')) {
      api.createRecord('0e28d537', component.options)
    } else {
      api.reload('0e28d537', component.options)
    }
    module.hot.accept("./ykInputs.vue?vue&type=template&id=0e28d537&scoped=true", function () {
      api.rerender('0e28d537', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/YkFormComponet/ykInputs.vue"
export default component.exports